import { SxProps, Theme } from '@mui/material';

export const dataGridContainerSx: SxProps<Theme> = {
  height: '100%',
  width: '100%',
  margin: 0,
  border: 'none',
  borderRadius: 0,
  overflow: 'hidden',
};
